import {
  administration_delete_fund_path,
  administration_archive_fund_path,
  admin_system_message_delete_path
} from '~/routes';

export const Administration = {

  feedback: function() {
    var table = jQuery('table#administration-feedback')
    table.DataTable({
      data: JSON.parse(jQuery('#feedback-data').html()),
      pageLength: 25,
      retrieve: true,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },

      aoColumnDefs: [
        {
          mRender: function(data, type, rowData) {
            return Object.keys(data).map(function(i){return data[i]}).join(' ');
          },
          orderable: false,
          searchable: false,
          aTargets: [-1]
        }
      ],
      drawCallback: function() {
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    });

		jQuery('a.mark-feedback-as-read').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      jQuery.post(jQuery(this).attr('href'), function() {
        alert(I18n.t('feedback_read'));
        Turbo.visit(window.location);
      });
      return false;
		});
  },

  fund_list: function() {
    if (!jQuery.fn.DataTable.isDataTable('table#administration-funds')) {
      ActionJS.Administration.priv.fundTable = jQuery('table#administration-funds').DataTable({
        data: JSON.parse(jQuery('#fund-table-data').html()),
        lengthChange: false,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        columnDefs: [
          {
            render: function(data, type, row, meta) {
              if (type == 'display') {
                return jQuery('#fund-identifier-template').html().
                  replace(/__id__/g, data.id).
                  replace(/__identifier__/g, data.identifier);
              }
              return data.identifier;
            },
            targets: [0]
          },
          {
            render: function(data, type, row, meta) {
              if (type == 'display') {
                return jQuery('#fund-actions-template').html().
                  replace(/__id__/g, data.id).
                  replace(/__archived__/g, data.archived).
                  replace(/__archive__/g, !data.archived ? I18n.t('archive') : I18n.t('unarchive'));
              }
              return '';
            },
            sorting: false,
            targets: [6]
          }
        ]
      });
    }

    $('#administration-funds').delegate('.fund-delete', 'click', function() {
      var $link = $(this); 
      if (confirm(I18n.t('confirm_delete_fund'))) {
        $.ajax({
          url: administration_delete_fund_path({fund_id: $(this).attr('data-fund-id'), format: null}),
          method: 'post'
        }).done(function(){
          ActionJS.Administration.priv.fundTable.row($link.closest('tr')).remove().draw();
        });
      }
      return false;
    });
    $('#administration-funds').delegate('.fund-archive', 'click', function() {
      var $link = $(this);
      var is_unarchived = $link.attr('data-archived') != 'true';
      if (confirm(I18n.t(is_unarchived ? 'confirm_archive_fund' : 'confirm_unarchive_fund'))) {
        $.ajax({
          url: administration_archive_fund_path({
            fund_id: $(this).attr('data-fund-id'), archive: is_unarchived.toString(), format: null}),
          method: 'post'
        }).done(function(data){
          $link.attr('data-archived', data.archived);
          $($link.find('span')[0]).text(I18n.t(data.archived ? 'unarchive' : 'archive'));
        });
      }
      return false;
    });
  },

  new_fund: function() {
    this.priv.fundForm()
  },

  edit_fund: function () {
    this.priv.fundForm()
  },

  create_fund: function() {
    this.priv.fundForm()
  },

  update_fund: function () {
    this.priv.fundForm()
  },

  system_message: function() {
    $('.system-message-delete').on('click', function () {
      var $link = $(this);
      if (confirm(I18n.t('confirm_delete_system_message'))) {
        $.ajax({
          url: admin_system_message_delete_path(),
          method: 'post'
        }).done(function () {
          Turbo.visit(window.location.href);
        });
      }
      return false;
    });
  },

  all_users: function() {
    if (!jQuery.fn.DataTable.isDataTable('table.admin-users-table')) {
      ActionJS.Monitoring.priv.externalUsersTable = jQuery('table.admin-users-table').DataTable(
        {
          serverSide: true,
          ajax: {
            url: jQuery('table.admin-users-table').data('url'),
            type: 'POST',
            dataSrc: function (json) {
              if (json.data.length > 0) {
                var data = [];
                for (var i = 0; i < json.data.length; i++) {
                  data.push(json.data[i]) ;
                }
                return data
              } else
                return json.data
            }
          },
          columnDefs: [
            {
              targets: 0,
              name: 'first_name'
            },
            {
              targets: 1,
              name: 'last_name'
            },
            {
              targets: 2,
              name: 'email_address'
            },
            {
              targets: 3,
              name: 'tenant'
            },
            {
              targets: 4,
              name: 'user_type'
            }
          ],
          lengthChange: false,
          pageLength: 20,
          autoWidth: false,
          language: {
            searchPlaceholder: I18n.t('search')
          },
          drawCallback: function() {
            DataTablesHelper.addColumnFilters(this);
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          }
        }
      );
      DataTablesHelper.searchDelay(ActionJS.Monitoring.priv.externalUsersTable, 1000);
    }
  },

  priv: {
    fundTable: null,

    fundForm: function () {
      jQuery('.select2').select2();
      jQuery('.datetimepicker').flatpickr({
        dateFormat: 'Y-m-d',
        allowInput: true
      });
    }
  }
}

export const UserAgreement = {

  list: function() {
      jQuery('.user-agreement-table').each(function(i, elem) {
          var agreementType = jQuery(this).attr('data-table-type');
          var tableIdPrefix = '#user-agreement-' + agreementType;
          var tableSelector = '#user-agreement-' + agreementType + '-table';
          if (!jQuery.fn.DataTable.isDataTable(tableSelector)) {
              this.table = jQuery(tableSelector).DataTable({
                data: JSON.parse(jQuery('#user-agreement-' + agreementType + '-json').text()),
                pageLength: 10,
                autoWidth: false,
                columnDefs: [
                  {
                    render: function(data, type, row, meta) {
                        if (type == 'display' && data.status == 'draft') {
                            return jQuery('#user-agreement-status-template').html()
                            .replace(/__nextLabel__/g, data.nextLabel)
                            .replace(/__nextStatus__/g, data.nextStatus)
                            .replace(/__label__/g, data.label)
                            .replace(/__status__/g, data.status)
                            .replace(/__id__/g, data.id);
                        }
                        return data.label;
                    },
                    targets: [2]
                  },
                  {
                    render: function(data, type, row, meta) {
                        if (type == 'display' && data.id) {
                          var content = jQuery('#user-agreement-action-template').html()
                              .replace(/__id__/g, data.id)
                              .replace(/__edit__/g, data.editable ? '' : 'hidden')
                              .replace(/__delete__/g, data.deletable ? '' : 'hidden');                          
                          return content;
                        }
                        return '';
                    },
                    orderable: false,
                    className: 'actions',
                    targets: [5]
                  }
                ],
                language: {
                  searchPlaceholder: I18n.t('search')
                },
                drawCallback: function() {
                  jQuery(elem).find('.update-agreement-status').off('click').on('click', function(e){
                    e.preventDefault();
                    var confirmed = confirm(jQuery(this).data('confirm-text'));
                    if (confirmed){
                      jQuery.post(jQuery(this).attr('href'), function(d){
                        location.reload();
                      });
                    }


                  });
              //    DataTablesHelper.fixForBS4(tableSelector);
                },
                footerCallback: function () {
                  DataTablesHelper.togglePagination(this);
                },
                initComplete: function() {
                    jQuery(tableSelector + '_length').addClass('float-xs-left').appendTo(tableIdPrefix + '-page-size-selector');
                    jQuery(tableSelector + '_filter').addClass('float-xs-right').appendTo(tableIdPrefix + '-filter');
            //        DataTablesHelper.addHorizontalScrollIndicator(tableIdPrefix + '-table');
                }
    
            } );
          }
      });
  },


  new: function() {
      // Content rich text editor
      jQuery('.modal-dialog').append(SmartME.loadingIndicator);
      TinyMCEHelper.init({
          selector: '#user_agreement_content',
          plugins: [
            'advlist autolink lists link charmap',
            'searchreplace visualblocks fullscreen',
            'insertdatetime table contextmenu paste'
        ],
          menu: {
            edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
            insert: {title: 'Insert', items: 'link media | template hr'},
            format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
            table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
          },
          relative_urls : false,
          remove_script_host : false,

          height : "480",
          
      });
  },


  edit: function() {
      ActionJS.UserAgreement.new();
  },

  copy: function() {
    const copyButton = $('#copy-ua-btn');
    copyButton.appendTo($('.modal-header')[0]);
    
    copyButton.bind('click', function() {
      const contentToCopy = $('.user-agreement-content');
      const range = document.createRange();
      range.selectNode(contentToCopy[0]);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
    });
  },

  _delete: function() {
      ActionJS.AdminCommon.deleteTableRow(jQuery(this), ActionJS.UserAgreement.table);
      return false;
  }
};
